export default function Therapist() {
  return (
    <section className="py-24 bg-[#faf8f2]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#3a4a28]/50 text-xs tracking-[0.4em] mb-4">THERAPIST</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2a2a1e]">
            セラピスト紹介
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-3xl mx-auto">
          <div className="relative">
            <div className="aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/98c8f721efe8e85064ec351cb642a7fc/3b59f4ec1d467c8a1d81f03bc83661b3.jpeg"
                alt="齊藤 友"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-sm rounded-sm px-5 py-4">
              <p className="font-serif text-xl text-[#2a2a1e]">齊藤 友</p>
              <p className="text-[#3a4a28] text-xs tracking-widest mt-1">Yu Saito</p>
            </div>
          </div>
          <div>
            <div className="mb-6">
              <h3 className="font-serif text-lg text-[#2a2a1e] mb-4 tracking-wide">
                プロフィール
              </h3>
              <p className="text-[#5a5a4a] text-sm leading-loose tracking-wide mb-4">
                身体の構造と動きを軸に、一人ひとりの状態に合わせた施術と指導を行う。某サロンにて経験を積み、独立。これまで多くのクライアントの不調改善や身体機能の向上に携わってきました。
              </p>
              <p className="text-[#5a5a4a] text-sm leading-loose tracking-wide">
                整体だけでなくトレーニングの知識も活かし、姿勢や動きの質までトータルでサポート。一時的な対処ではなく、身体を根本から整え、本来のバランスと機能を取り戻すことを大切にしています。
              </p>
            </div>
            <div className="border-t border-[#e8e4d8] pt-6">
              <h4 className="text-xs text-[#3a4a28] tracking-widest mb-4">資格・経歴</h4>
              <ul className="space-y-2">
                {[
                  "整体ボディケアセラピスト",
                  "スポーツ整体ボディケアセラピスト",
                  "リラクゼーション整体ボディケアセラピスト",
                  "ボディメイクインストラクター",
                  "JADP認定 体幹トレーナー",
                  "筋膜リリースセラピスト",
                  "疲労回復インストラクター",
                  "キックボクシングプロライセンス",
                ].map((qual, i) => (
                  <li key={i} className="text-[#6a6a5a] text-sm tracking-wide flex items-center gap-2">
                    <div className="w-1 h-1 bg-[#3a4a28] rounded-full flex-shrink-0" />
                    {qual}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
